<rappider-spin [spinning]="isLoading">
  <ng-container *ngIf="sourceSchema && targetSchema">
    <rappider-data-transformation [dataTransformationId]="dataTransformationId"
                                  [schema]="sourceSchema"
                                  [targetSchema]="targetSchema"></rappider-data-transformation>
  </ng-container>
</rappider-spin>
